import { Checkbox, Collapse } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const GrowthChart: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center fill-darwin-accent-bright-blue-800">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 512"
                            className="w-16 h-12 fill-blue transform scale-125"
                        >
                            <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={
                    <div className="font-700" id="growth-chart-left-id">
                        {sectionName || 'Growth Chart Indicators [WHO/IAP]'}
                    </div>
                }
                key="growthChart"
            >
                <p className="mr-16 space-y-2">
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.growth_chart_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        growth_chart_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            growth_chart_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Key</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.growth_chart_name_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        growth_chart_name_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            growth_chart_name_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.growth_chart_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        growth_chart_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            growth_chart_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default GrowthChart;
